
// WordPressの更新読み込む


import CaracolWordpressJson from '../caracol_es2015.1.0/wordpress/wpjson';

export default function () {

    const wpJsonFormat = '<li><a href="{%LINK%}" class="home-news__link">' +
        '<span class="home-news__day">{%POSTDAY%}</span> ' +
        '<span class="home-news__category">{%CATEGORY_NAME%}</span><br>' +
        '<span class="home-news__title">{%TITLE%}</span></a></li>';

    const wpJson = new CaracolWordpressJson({
        format: wpJsonFormat,
        onComplete: onWpJsonLoad
    });
    wpJson.load('/news/wordpress/output/export_new_json.php');

    /**
    * WordPressの更新履歴を読んだら実行
    */
    function onWpJsonLoad(outputArray) {
        $('.js-news-content').append(outputArray.join(''));
    }

}



// WEBPACK FOOTER //
// ./js/module/wordpress.js